import React from "react";

import { AutocompleteChangeReason } from "@mui/material";

import { MultipleAutocompleteChip } from "@/components/forms/MultipleAutocompleteChip";

type TemplateAttributionSelectorProps = {
  saasList: {
    id: number;
    name: string;
  }[];
  companySaasList: {
    id: number;
    name: string;
  }[];
  onChange: (
    newSaasList: { id: number; name: string }[],
    reason: AutocompleteChangeReason,
  ) => void;
};

const TemplateAttributionSelector = ({
  saasList,
  companySaasList,
  onChange,
}: TemplateAttributionSelectorProps) => {
  return (
    <MultipleAutocompleteChip
      options={saasList}
      onChange={onChange}
      value={companySaasList}
    />
  );
};

export default TemplateAttributionSelector;
